import { PremierPartnerDTO } from "../DTO/premierPartnerDTO";
import { PremierService } from "./premierService";

export class PremierPartner{
    public id!: number;
    public name!: string;
    public providerName!: string; //used in ExternalApiRequestProvider to route service to correct service api
    public premierServices!: PremierService[];
    public added!: Date;
    public edited!: Date;

    constructor(){
        this.premierServices = new Array();
    }

    public static mapFromDTO(param:PremierPartnerDTO):PremierPartner{
        if(!param) throw new Error("parameter is null");
        let obj = new PremierPartner();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.providerName = param.providerName;
            if(param.premierServiceList) obj.premierServices = param.premierServiceList.map(ps=>PremierService.mapFromDTO(ps));
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }

        return obj;
    }

    public static mapToDTO(param:PremierPartner):PremierPartnerDTO{
        if (!param) throw new Error("parameter is null")
        let dto = new PremierPartnerDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.providerName = param.providerName;
            if(dto.premierServiceList) dto.premierServiceList = param.premierServices.map(ps=>PremierService.mapToDTO(ps));
            if(dto.added) dto.added = param.added.toISOString();
            if(dto.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}